import * as React from "react";

type Props = {
  name: string;
  completed: number;
  prepend?: any;
  total: number;
};
export default (props: Props) => (
  <div className="title">
    {props.prepend}

    <span className="sub-title">{props.name}</span>

    <span>{`${props.completed}/${props.total}`}</span>
  </div>
);
